import { render, staticRenderFns } from "./NovaSenha.vue?vue&type=template&id=0fef0ffe&scoped=true"
import script from "./NovaSenha.vue?vue&type=script&lang=js"
export * from "./NovaSenha.vue?vue&type=script&lang=js"
import style0 from "./NovaSenha.vue?vue&type=style&index=0&id=0fef0ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef0ffe",
  null
  
)

export default component.exports